<template>
  <component :is="layout">
    <slot />
  </component>
</template>

<script>
const defaultLayout = "PrincipalLayout";

export default {
  name: "Layout",
  computed: {
    layout() {
      let layout = this.$route.meta.layout || defaultLayout;
      return () => import(`@/layouts/${layout}.vue`);
    },
  },
};
</script>
